import {useAiChatSize} from '@AiChat/hooks/useAiChatSize';
import {useAiChat} from '@AiChat/providers/ai-chat.context';
import type {AiChatLayoutState} from '@AiChat/hooks/useAiChatLayout.types';

export function useAiChatLayout(): AiChatLayoutState {
  const {isSmall, isCompact} = useAiChatSize();
  const {state} = useAiChat();
  const isMobileLayout = state.isEmbedded ? isSmall : isCompact;
  const floatsSidebarOverChat = isMobileLayout || (state.isEmbedded && isCompact);

  return {
    isMobileLayout,
    floatsSidebarOverChat,
    showsSidebarRail: !isMobileLayout && (floatsSidebarOverChat || !state.isSidebarExpanded),
  };
}
